export const AUTH_TABS = {
  REGISTER: "register",
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot-password",
} as const

export const ROUTER_PATHS = {
  HOME: "/",
  //   USER
  USER: "/user",
  USER_RESET_PASSWORD: "/user/reset-password/:code",
  NOT_FOUND: "/404",
  //   AUTH
  AUTH: "/auth",
  AUTH_LOGIN: `/auth?tab=${AUTH_TABS.LOGIN}`,
  AUTH_REGISTER: `/auth?tab=${AUTH_TABS.REGISTER}`,
  AUTH_FORGOT_PASSWORD: `/auth?tab=${AUTH_TABS.FORGOT_PASSWORD}`,
  //   APP
  APP: "/app",
  APP_LIBRARY: "/app/library",
  APP_LIBRARY_DETAILS: "/app/library/:id",
  //   PROFILE
  PROFILE: "/profile",
  PROFILE_CHANGE_EMAIL: "/profile/change-email",
  PROFILE_APPLY_PROMO_CODE: "/profile/apply-promo-code",
  PROFILE_CHANGE_VOICE: "/profile/change-voice",
  PROFILE_LANGUAGE: "/profile/language",
  PROFILE_DELETE_ACCOUNT: "/profile/delete-account",
  PROFILE_CHANGE_PASSWORD: "/profile/change-password",
  PROFILE_MANAGE_SUBSCRIPTION: "/profile/manage-subscription",
  PROFILE_CONTACT_US: "/profile/contact-us",
  PROFILE_AUTH_SESSIONS: "/profile/sessions",
  PROFILE_CONNECT_EMAIL: "/profile/connect-email",
  GUEST_UPGRADE: "/guest-upgrade",
  //   CHECKOUT
  CHECKOUT: "/checkout",
  //   APP DOWNLOAD
	DOWNLOAD_APP: "/download-app",
}
